module.exports = __webpack_public_path__ + "static/media/yg-interiors.93a02905.png";